<section class="feature-page">
  <app-page-header
    icon="groups"
    title="Colaboraciones"
    subtitle="Gestiona las colaboraciones y roles disponibles para las personas">
  </app-page-header>

  <div class="feature-page__content">
    <mat-card class="table-surface-card">
      <mat-card-content>
        <app-table-surface
            [columns]="columns"
            [data]="tableData"
            [isLoading]="isLoading"
            [cellTemplate]="cellContent"
            [savingCell]="savingCell"
            [activeFilters]="activeFilterChips"
            tableId="activity-list"
            [enableSearch]="true"
            searchPlaceholder="Buscar colaboracion..."
            [enableFilter]="true"
            [enableColumnVisibility]="true"
            [enableDensity]="true"
            primaryActionLabel="Nuevo"
            (searchChange)="onToolbarSearch($event)"
            (filterRemove)="onFilterRemove($event)"
            (cellEditSave)="onCellEditSave($event)"
            (primaryActionClick)="createNew()">
            <div filterPanel class="activity-filter-panel" [formGroup]="filterForm">
              <app-data-table-multi-select-filter formControlName="status" label="Estado" [options]="statusFilterOptions"></app-data-table-multi-select-filter>
              <app-data-table-multi-select-filter formControlName="areaId" label="Área" [options]="areaSelectOptions"></app-data-table-multi-select-filter>
              <app-data-table-multi-select-filter formControlName="level" label="Nivel" [options]="levelSelectOptions"></app-data-table-multi-select-filter>

            </div>
          </app-table-surface>

        <ng-template #cellContent let-column="column" let-row="row">
          <span *ngIf="column === 'name'">{{ row.name }}</span>
          <span *ngIf="column === 'area'">{{ getAreaLabel(row) }}</span>
          <span *ngIf="column === 'organizationLevel'">{{ getLevelsText(row) }}</span>
          <span *ngIf="column === 'roles'">{{ getRolesText(row) }}</span>
          <mat-slide-toggle
            *ngIf="column === 'isActive'"
            class="status-toggle"
            [checked]="row.isActive"
            (click)="$event.stopPropagation()"
            (change)="onStatusChange(row, $event.checked)"
            aria-label="Cambiar estado">
          </mat-slide-toggle>

          <div *ngIf="column === 'actions'" class="actions-cell">
            <button mat-icon-button matTooltip="Editar" (click)="$event.stopPropagation(); editActivity(row)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button matTooltip="Eliminar" (click)="$event.stopPropagation(); deleteActivity(row)">
              <mat-icon color="warn">delete</mat-icon>
            </button>
          </div>
        </ng-template>
      </mat-card-content>
    </mat-card>
  </div>
</section>
